// Firmware step table in enum/index order from frequencies.c / frequencies.h.
// Values are in kHz for UI use.
export const STEP_TABLE_KHZ: readonly number[] = [
  2.5,
  5,
  6.25,
  10,
  12.5,
  25,
  8.33,
  0.01,
  0.05,
  0.1,
  0.25,
  0.5,
  1,
  1.25,
  9,
  15,
  20,
  30,
  50,
  100,
  125,
  200,
  250,
  500
];

export const STEP_INDEX_0_5_KHZ = 11;
export const TELEMETRY_MAX_STEP_KHZ = 5;

export function stepIndexToKhz(index: number): number | null {
  if (!Number.isInteger(index) || index < 0 || index >= STEP_TABLE_KHZ.length) {
    return null;
  }
  return STEP_TABLE_KHZ[index];
}

export function isTelemetryStepAllowed(index: number): boolean {
  const khz = stepIndexToKhz(index);
  return khz !== null && khz <= TELEMETRY_MAX_STEP_KHZ;
}

export function formatStepKhz(index: number): string {
  const khz = stepIndexToKhz(index);
  if (khz === null) {
    return `Unknown (${index})`;
  }
  return `${khz} kHz`;
}

export function telemetryAllowedStepIndexes(): number[] {
  const indexes: number[] = [];
  for (let i = 0; i < STEP_TABLE_KHZ.length; i += 1) {
    if (isTelemetryStepAllowed(i)) {
      indexes.push(i);
    }
  }
  return indexes;
}

export interface StepOption {
  index: number;
  khz: number;
}

export function telemetryAllowedStepOptionsSorted(): StepOption[] {
  const options = telemetryAllowedStepIndexes().map((index) => ({
    index,
    khz: STEP_TABLE_KHZ[index]
  }));
  options.sort((a, b) => {
    if (a.khz === b.khz) {
      return a.index - b.index;
    }
    return a.khz - b.khz;
  });
  return options;
}
